import { Image } from "@shared/render/image";
import { useSettingsStore } from "@shared/store/settings.store";
import { Badge } from "@shared/ui/badge";
import { format } from "date-fns";
import { FormattedMessage } from "react-intl";

export type TableCellProps = {
	value: string;
};

export type TableBoolenProps = {
	value: boolean;
};

export function TableDateCell({ value }: TableCellProps) {
	const dateFormat = useSettingsStore((state) => state.dateFormat);

	return <span className="">{format(value, dateFormat)}</span>;
}

export function TableBooleanCell({ value }: TableBoolenProps) {
	if (value) {
		return (
			<Badge>
				<FormattedMessage id="common.boolean.true" defaultMessage="TRUE" />
			</Badge>
		);
	}
	return (
		<Badge variant="destructive">
			<FormattedMessage id="common.boolean.false" defaultMessage="FALSE" />
		</Badge>
	);
}

export function TableBadgenCell({ value }: TableCellProps) {
	return <Badge>{value}</Badge>;
}

export function TableImageCell({ value }: TableCellProps) {
	return (
		<Image
			src={value}
			alt="table-cell-image"
			width={30}
			height={30}
			loading="lazy"
			allowFullscreen
			className="rounded ml-2"
		/>
	);
}
